import(/* webpackMode: "eager" */ "C:\\Users\\GBCI03\\Documents\\GitHub\\website-v1\\src\\app\\academy\\page.tsx")